import { render, staticRenderFns } from "./modal-viewer-ficha.vue?vue&type=template&id=7b5c9980&"
import script from "./modal-viewer-ficha.vue?vue&type=script&lang=js&"
export * from "./modal-viewer-ficha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports